import { Field } from "react-final-form";
import { Row, Col } from "react-bootstrap";
import { Icon } from "@mui/material";
import BMXSeparator from "../../../../../../Components/Separator/BMXSeparator";
import BMXTextField from "../../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXDatePicker from "../../../../../../Components/Inputs/BMXDatePicker/BMXDatePicker";
import "./ServiceRealizationFormStepOne.scss";
import { useCallback, useEffect, useState } from "react";
import { ServiceIcon } from "../../../../../../Components/Icons/serviceDeliveryIcon/ServiceIcon";

import { useTranslation } from "react-i18next";
import BMXSelectField from "../../../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import { GlobalAuthFetch } from "../../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { SERVICE_FLAGS } from "../../../../../../Utils/ServiceUtils/serviceFlags";
import PauseScreen from "../PauseScreen";

const ServiceRealizationFormStepOne = (props) => {
  const { t } = useTranslation();
  const { values, form, initialValues, loadData, handleTogglePause } = props;
  const selectedCarsOnInitial =
    initialValues?.carRegistrationNumbers?.map((el) => ({
      value: el.uuid,
      name: `${el?.model?.entryName} ${el?.registrationNumber}`,
      uuid: el.uuid,
    })) || [];

  const [allCars, setAllCars] = useState([]);

  const executionMethodOptions = [
    {
      value: "customerIntervention",
      icon: "airport_shuttle",
      label: "U klienta",
    },
    {
      value: "localIntervention",
      icon: "apartment",
      label: "Lokalnie",
    },
    {
      value: "remoteIntervention",
      icon: "headset_mic",
      label: "Zdalnie",
    },
  ];

  useEffect(() => {
    // LOADING DICTIONARIES
    const fetchData = async () => {
      const carsFetch = GlobalAuthFetch({
        path: "/car/all",
      });

      const [carsPayload] = await Promise.all([carsFetch]);

      if (carsPayload?.payload.status === 200) {
        const { data } = carsPayload.payload;

        setAllCars(
          data.map((e) => ({
            value: e.uuid,
            name: `${e.model.entryName} ${e.registrationNumber}`,
            uuid: e.uuid,
          })),
        );
      }
    };

    fetchData();
  }, []);

  const renderExecutionMethodIcon = ({ value, icon, label }) => {
    const selected = values?.executionTechnicMethod === value;

    return (
      <div
        onClick={() => form.change("executionTechnicMethod", value)}
        title={label}
        style={{
          width: 36,
          height: 36,
          borderRadius: 8,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          transition: "all 0.2s ease",
        }}
      >
        <ServiceIcon executionMethod={value} selected={selected} />
      </div>
    );
  };

  const handleStart = useCallback(() => {
    if (!values?.startDateTime) {
      form.change("startDateTime", new Date());
    }
  }, [form, values?.startDateTime]);

  const handleStop = useCallback(() => {
    if (!values?.endDateTime && !values?.pause) {
      form.change("endDateTime", new Date());
    }
  }, [form, values?.endDateTime, values?.pause]);

  const renderBooleanTile = (name, label) => {
    const checked = Boolean(values?.[name]);

    return (
      <div
        onClick={() => form.change(name, !checked)}
        style={{
          padding: "8px 12px",
          borderRadius: "6px",
          backgroundColor: checked ? "#FFF3CD" : "#F5F5F5",
          fontWeight: checked ? "bold" : "normal",
          fontSize: "0.8rem",
          cursor: "pointer",
          userSelect: "none",
          textAlign: "center",
        }}
      >
        {label}
      </div>
    );
  };

  const renderTimeColumn = (name, label) => {
    const value = Number(values?.[name]) || 0;

    return (
      <div className="time-column">
        <div className="time-label">{label}</div>

        <Icon
          className="time-btn plus"
          onClick={() => form.change(name, value + 0.5)}
        >
          add
        </Icon>

        <div className="time-value">{value}h</div>

        <Icon
          className="time-btn minus"
          onClick={() => form.change(name, Math.max(0, value - 0.5))}
        >
          remove
        </Icon>
      </div>
    );
  };

  if (values?.pause) {
    return <PauseScreen handleTogglePause={handleTogglePause} />;
  }

  return (
    <div className="ServiceRealizationForm">
      <BMXSeparator title="ROZLICZENIE WYKONANEJ USŁUGI" />

      <div className="service-grid">
        {/* START / STOP oraz PAUZA OBOK */}
        <div className="start-stop-container-with-pause">
          {/* Kolumna po lewej: Start i Stop pod soba */}
          <div className="start-stop-column">
            <div className="start-stop-column-row">
              <button
                type="button"
                disabled={
                  values?.startDateTime ||
                  !values?.technicianOrTeamLeader ||
                  !values?.plannedServiceDateTime
                }
                className="start-stop-btn start"
                onClick={handleStart}
              >
                Start
              </button>

              <Field
                name="startDateTime"
                readOnly
                component={BMXDatePicker}
                label="Data i czas"
                showTime={true}
                id="service-startDateTime"
              />
            </div>

            <div className="start-stop-column-row">
              <button
                type="button"
                disabled={values?.endDateTime || !values?.startDateTime}
                className="start-stop-btn stop"
                onClick={handleStop}
                style={{
                  cursor:
                    values?.endDateTime || !values?.startDateTime
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                Stop
              </button>

              <Field
                name="endDateTime"
                readOnly
                component={BMXDatePicker}
                showTime={true}
                label="Data i czas"
                id="service-endDateTime"
              />
            </div>
          </div>

          {initialValues?.startDateTime && (
            <div className="pause-action-wrapper">
              <button
                type="button"
                disabled={
                  !initialValues?.startDateTime || Boolean(values?.endDateTime)
                }
                onClick={handleTogglePause}
                title="Przerwa (Pauza)"
                className="pause-action-btn"
              >
                <Icon style={{ color: "#1BB28C", fontSize: "22px" }}>
                  pause
                </Icon>
              </button>
              <span className="pause-action-label">Pauza</span>
            </div>
          )}
        </div>

        {/* CZASY */}
        {renderTimeColumn("inspectionTimeCounter", "PRZEGLĄD")}
        {renderTimeColumn("repairTimeCounter", "NAPRAWA")}
        {renderTimeColumn("implementationTimeCounter", "WDROŻENIE")}
        {renderTimeColumn("diagnosticsTimeCounter", "DIAGNOSTYKA")}
        {renderTimeColumn("itServiceTimeCounter", "USŁUGA IT")}
      </div>

      <BMXSeparator title="POJAZD" />

      <Row>
        <Col xs={6}>
          <Field
            data-cy="carRegistrationNumbers"
            multiple
            component={BMXSelectField}
            values={allCars}
            selectedValues={values}
            displayEmpty
            initialValues={{
              carRegistrationNumbers: selectedCarsOnInitial,
            }}
            label={`${t("global:service.carRegistrationNumbers")}`}
            name="carRegistrationNumbers"
            renderValue={(el) => {
              return el.map((e) => e.name).join(", ");
            }}
          />
        </Col>

        <Col xs={3}>
          <Field
            name="initialCounter"
            component={BMXTextField}
            type="number"
            label="Licznik początkowy"
          />
        </Col>

        <Col xs={3}>
          <Field
            name="finalCounter"
            component={BMXTextField}
            type="number"
            label="Licznik końcowy"
          />
        </Col>
      </Row>

      <BMXSeparator title="INFORMACJE SZCZEGÓŁOWE" />

      <Row className="g-2">
        {SERVICE_FLAGS.map((flag) => (
          <Col xs={3} key={flag.name}>
            {renderBooleanTile(flag.name, flag.defaultLabel)}
          </Col>
        ))}
      </Row>

      <Col>
        <Field
          name="interventionScope"
          component={BMXTextField}
          label="Zakres wykonanej interwencji"
          multiline
          style={{ marginBottom: "0px" }}
        />
      </Col>

      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          padding: "12px 0",
        }}
      >
        {executionMethodOptions.map((option) => (
          <div key={option.value}>{renderExecutionMethodIcon(option)}</div>
        ))}
      </div>
    </div>
  );
};

export default ServiceRealizationFormStepOne;
